export type ConsoleListenerMethod = 'warn' | 'error'
type ConsoleListener = (method: ConsoleListenerMethod, args: unknown[]) => void

const methods: ConsoleListenerMethod[] = ['warn', 'error']
const listeners = new Set<ConsoleListener>()
const patches: Partial<Record<ConsoleListenerMethod, { original: Console[ConsoleListenerMethod], wrapper: Console[ConsoleListenerMethod] }>> = {}

function patchConsole() {
    for (const method of methods) {
        const original = console[method]
        const wrapper = (...args: unknown[]) => {
            original.apply(console, args)
            // A wrapper left under a later patch (see restoreConsole) must not notify again once re-patched
            if (patches[method]?.wrapper === wrapper) listeners.forEach(listener => listener(method, args))
        }
        patches[method] = { original, wrapper }
        console[method] = wrapper
    }
}

function restoreConsole() {
    for (const method of methods) {
        // Overwriting a patch installed after ours (e.g. Elastic APM) would drop it
        if (console[method] === patches[method]?.wrapper) console[method] = patches[method].original
        delete patches[method]
    }
}

// One shared patch for all listeners, so overlapping add/remove order can never leave a stale wrapper installed
export function addConsoleListener(listener: ConsoleListener) {
    if (!listeners.size) patchConsole()
    listeners.add(listener)

    return () => {
        if (!listeners.delete(listener)) return
        if (!listeners.size) restoreConsole()
    }
}
